import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_flex _ai-c _gap-2" }
const _hoisted_2 = { class: "_pa-2" }
const _hoisted_3 = { class: "_flex _flexwrap" }
const _hoisted_4 = { class: "_flex _ai-c" }
const _hoisted_5 = {
  key: 1,
  class: "_flex _jc-c _ai-c _gap-1",
  "data-qa": "digital-content:AccessPending"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_text = _resolveComponent("base-text")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_indicator_dot = _resolveComponent("base-indicator-dot")
  const _component_digital_content_terms_modal = _resolveComponent("digital-content-terms-modal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['_mt-2 _pa-2 _bg-color-light _rounded--common _jc-sb _tal _gap-2', $options.flexDirectionClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_icon, {
          size: "lg",
          name: "file",
          class: "_tc--accent"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_text, {
          as: "div",
          class: "_tc--dark"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.item.orderItemName), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_3, [
          ($props.item.downloadedAt)
            ? (_openBlock(), _createBlock(_component_base_text, {
                key: 0,
                as: "div",
                class: "_mr-2",
                level: "caption",
                "data-qa": "digital-content:DownloadDate"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.downloadedAtLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          ($options.isLastUpdatedAtVisible)
            ? (_openBlock(), _createBlock(_component_base_text, {
                key: 1,
                as: "div",
                level: "caption"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.revealedAtLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode(_component_base_text, {
          as: "div",
          level: "caption"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.item.orderItemOptions), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      ($props.item.isAccessGranted)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            enabled: $options.hasAccessToMissingFile,
            text: _ctx.Resources.YourPledge.DigitalContentMissingFileTooltip
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon_base_button, {
                icon: "download",
                theme: "accent",
                disabled: $options.hasAccessToMissingFile,
                onClick: _withModifiers($options.onDownloadClick, ["prevent"]),
                "data-qa": "digital-content:DownloadButton"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.DigitalContentDownloadFileButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["enabled", "text"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_base_indicator_dot, { color: "info" }),
            _createTextVNode(" " + _toDisplayString(_ctx.Resources.YourPledge.DigitalContentAccessPendingStatus) + " ", 1 /* TEXT */),
            _createVNode(_component_tooltip, {
              "icon-name": "info-circle",
              text: _ctx.Resources.YourPledge.DigitalContentAccessPendingTooltip
            }, null, 8 /* PROPS */, ["text"])
          ]))
    ]),
    ($data.isTermsModalVisible)
      ? (_openBlock(), _createBlock(_component_digital_content_terms_modal, {
          key: 0,
          "is-visible": $data.isTermsModalVisible,
          onClose: $options.onTermsModalClose,
          onConfirm: $options.downloadFile
        }, null, 8 /* PROPS */, ["is-visible", "onClose", "onConfirm"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}